export default "__VITE_ASSET__D1_VkUqY__"